module.exports = __webpack_public_path__ + "img/mt5_bg1.070a9a8d.png";